import { render, staticRenderFns } from "./course-history.vue?vue&type=template&id=00cddc86&scoped=true&"
import script from "./course-history.vue?vue&type=script&lang=js&"
export * from "./course-history.vue?vue&type=script&lang=js&"
import style0 from "./course-history.vue?vue&type=style&index=0&id=00cddc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cddc86",
  null
  
)

export default component.exports